// this is used to pass an attribute as a selector into create selector

export function selectEcho<T, S = unknown>(_state: S, input: T): T {
	return input;
}
